import { render, staticRenderFns } from "./ProcessAssetsComponent.vue?vue&type=template&id=105e6507&"
import script from "./ProcessAssetsComponent.vue?vue&type=script&lang=js&"
export * from "./ProcessAssetsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports